import React, { useState } from 'react'
import { Button } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

export const CopyButton: React.FC<{ copyText: string }> = ({ copyText }) => {
  const { t } = useTranslation(['common'])
  const [hasCopyError, setHasCopyError] = useState(false)

  const copy = async () => {
    setHasCopyError(false)
    try {
      await navigator.clipboard.writeText(copyText)
    } catch {
      setHasCopyError(true)
    }
  }

  return (
    <div className="flex flex-col items-end">
      <Button
        title={t('common:copy')}
        icon="copy"
        secondary
        className="flex items-center justify-center size-8 border-2 rounded-md border-brand-6"
        onClick={copy}
      />
      <div aria-live="polite" className="text-xs text-red-800 mt-xs text-right">
        {hasCopyError ? t('copyFailed') : null}
      </div>
    </div>
  )
}
